<script setup lang="ts">
defineProps({
  message: {
    type: String,
    default: 'No data available'
  }
})
</script>

<template>
  <div class="text-center py-10">
    <Icon
      name="i-heroicons-bell-slash"
      class="h-12 w-12 text-gray-400 mx-auto mb-4"
    />
    <h3 class="mt-2 text-lg font-medium text-gray-900">
      No data available
    </h3>
    <p class="mt-1 text-sm text-gray-500">
      {{ message }}
    </p>
  </div>
</template>
